export default "__VITE_ASSET__CW9yWpKD__"